import { Route } from '@angular/router';
import { authGuard, guestGuard } from 'core/guards/auth.guard';
import { roleGuard } from 'core/guards/role.guard';

export const appRoutes: Route[] = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'session-expired',
    loadComponent: () =>
      import('./pages/session-expired/session-expired').then(
        (m) => m.SessionExpired,
      ),
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./pages/maintenance/maintenance').then((m) => m.Maintenance),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback').then((m) => m.AuthCallback),
  },
  {
    path: 'validar',
    loadComponent: () =>
      import('./pages/school-documents/verify/school-document-verify').then(
        (m) => m.SchoolDocumentVerify,
      ),
  },
  {
    path: 'validar/:code',
    loadComponent: () =>
      import('./pages/school-documents/verify/school-document-verify').then(
        (m) => m.SchoolDocumentVerify,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [roleGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'setup-wizard',
        loadComponent: () =>
          import('./pages/setup-wizard/setup-wizard').then(
            (m) => m.SetupWizard,
          ),
      },
      {
        path: 'create',
        loadComponent: () =>
          import('./pages/cpanel-hub/cpanel-hub-page').then(
            (m) => m.CpanelHubPage,
          ),
        data: { hub: 'create' },
      },
      {
        path: 'link',
        loadComponent: () =>
          import('./pages/cpanel-hub/cpanel-hub-page').then(
            (m) => m.CpanelHubPage,
          ),
        data: { hub: 'link' },
      },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/cpanel-hub/cpanel-hub-page').then(
            (m) => m.CpanelHubPage,
          ),
        data: { hub: 'list' },
      },
      {
        path: 'diary',
        loadComponent: () =>
          import('./pages/cpanel-hub/cpanel-hub-page').then(
            (m) => m.CpanelHubPage,
          ),
        data: { hub: 'diary' },
      },
      {
        path: 'trash',
        loadComponent: () =>
          import('./pages/cpanel-hub/cpanel-hub-page').then(
            (m) => m.CpanelHubPage,
          ),
        data: { hub: 'trash' },
      },
      {
        path: 'institutions',
        loadChildren: () =>
          import('./pages/institutions/institutions.routes').then(
            (m) => m.institutionsRoutes,
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./pages/users/users.routes').then((m) => m.usersRoutes),
      },
      {
        path: 'students',
        loadChildren: () =>
          import('./pages/students/students.routes').then(
            (m) => m.studentsRoutes,
          ),
      },
      {
        path: 'teachers',
        loadChildren: () =>
          import('./pages/teachers/teachers.routes').then(
            (m) => m.teachersRoutes,
          ),
      },
      {
        path: 'support-staff',
        loadChildren: () =>
          import('./pages/support-staff/support-staff.routes').then(
            (m) => m.supportStaffRoutes,
          ),
      },
      {
        path: 'classes',
        loadChildren: () =>
          import('./pages/classes/classes.routes').then((m) => m.classesRoutes),
      },
      {
        path: 'transfers',
        loadChildren: () =>
          import('./pages/transfers/transfers.routes').then(
            (m) => m.transfersRoutes,
          ),
      },
      {
        path: 'enrollments',
        loadChildren: () =>
          import('./pages/enrollments/enrollments.routes').then(
            (m) => m.enrollmentsRoutes,
          ),
      },
      {
        path: 'class-teachers',
        loadChildren: () =>
          import('./pages/class-teachers/class-teachers.routes').then(
            (m) => m.classTeachersRoutes,
          ),
      },
      {
        path: 'academic-courses',
        loadChildren: () =>
          import('./pages/academic-courses/academic-courses.routes').then(
            (m) => m.academicCoursesRoutes,
          ),
      },
      {
        path: 'subjects',
        loadChildren: () =>
          import('./pages/subjects/subjects.routes').then(
            (m) => m.subjectsRoutes,
          ),
      },
      {
        path: 'courses',
        loadChildren: () =>
          import('./pages/courses/courses.routes').then((m) => m.coursesRoutes),
      },
      {
        path: 'school-calendars',
        loadChildren: () =>
          import('./pages/school-calendars/school-calendars.routes').then(
            (m) => m.schoolCalendarsRoutes,
          ),
      },
      {
        path: 'guardians',
        loadChildren: () =>
          import('./pages/guardians/guardians.routes').then(
            (m) => m.guardiansRoutes,
          ),
      },
      {
        path: 'student-guardians',
        loadChildren: () =>
          import('./pages/student-guardians/student-guardians.routes').then(
            (m) => m.studentGuardiansRoutes,
          ),
      },
      {
        path: 'pickup-desk',
        loadChildren: () =>
          import('./pages/pickup-desk/pickup-desk.routes').then(
            (m) => m.pickupDeskRoutes,
          ),
      },
      {
        path: 'school-access',
        loadChildren: () =>
          import('./pages/school-access/school-access.routes').then(
            (m) => m.schoolAccessRoutes,
          ),
      },
      {
        path: 'school-exit',
        loadChildren: () =>
          import('./pages/school-exit/school-exit.routes').then(
            (m) => m.schoolExitRoutes,
          ),
      },
      {
        path: 'attendances',
        loadChildren: () =>
          import('./pages/attendances/attendances.routes').then(
            (m) => m.attendancesRoutes,
          ),
      },
      {
        path: 'grades',
        loadChildren: () =>
          import('./pages/grades/grades.routes').then((m) => m.gradesRoutes),
      },
      {
        path: 'report-cards',
        loadChildren: () =>
          import('./pages/report-cards/report-cards.routes').then(
            (m) => m.reportCardsRoutes,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.routes').then((m) => m.reportsRoutes),
      },
      {
        path: 'school-documents',
        loadChildren: () =>
          import('./pages/school-documents/school-documents.routes').then(
            (m) => m.schoolDocumentsRoutes,
          ),
      },
      {
        path: 'census',
        loadChildren: () =>
          import('./pages/census/census.routes').then((m) => m.censusRoutes),
      },
      {
        path: 'guardian-consents',
        loadChildren: () =>
          import('./pages/guardian-consents/guardian-consents.routes').then(
            (m) => m.guardianConsentsRoutes,
          ),
      },
      {
        path: 'class-diary',
        loadChildren: () =>
          import('./pages/class-diary/class-diary.routes').then(
            (m) => m.classDiaryRoutes,
          ),
      },
      {
        path: 'lesson-plans',
        loadChildren: () =>
          import('./pages/lesson-plans/lesson-plans.routes').then(
            (m) => m.lessonPlansRoutes,
          ),
      },
      {
        path: 'class-schedules',
        loadChildren: () =>
          import('./pages/class-schedules/class-schedules.routes').then(
            (m) => m.classSchedulesRoutes,
          ),
      },
      {
        path: 'classroom-seating',
        loadChildren: () =>
          import('./pages/classroom-seating/classroom-seating.routes').then(
            (m) => m.classroomSeatingRoutes,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings').then((m) => m.Settings),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('components/profile/profile.routes').then(
            (m) => m.profileRoutes,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/list/notifications-list').then(
            (m) => m.NotificationsList,
          ),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/platform-search/platform-search').then(
            (m) => m.PlatformSearchPage,
          ),
      },
      {
        path: 'notifications/trash',
        loadComponent: () =>
          import('./pages/notifications/trash/notifications-trash').then(
            (m) => m.NotificationsTrash,
          ),
      },
      {
        path: 'tickets',
        loadChildren: () =>
          import('./pages/tickets/tickets.routes').then((m) => m.ticketsRoutes),
      },
      {
        path: 'system-logs',
        loadComponent: () =>
          import('./pages/system-logs/list/system-logs-list').then(
            (m) => m.SystemLogsList,
          ),
      },
    ],
  },
];
